export default function useIsAndroid() {
  const userAgent = navigator.userAgent;
  if (/iPhone/i.test(userAgent)) {
    return false;
  }
  if (/Android/i.test(userAgent)) {
    return true;
  }
}
